import { IconType } from "react-icons";
import { FaCheck, FaExclamation, FaInfo, FaTimes } from "react-icons/fa";
import { IconProps, Icons, TypeOptions } from "react-toastify";

import { TOAST_MASCOT_SRC } from "./data";
import { MascotFace, MascotRing, StatusBadge } from "./styles";

const BADGES: Partial<Record<TypeOptions, IconType>> = {
  success: FaCheck,
  error: FaTimes,
  warning: FaExclamation,
  info: FaInfo,
};

/** The icon of every toast: the mascot delivering the message. Decoration, so hidden from readers. */
export const ToastMascot = ({ type, isLoading }: IconProps) => {
  if (isLoading) return <Icons.spinner />;

  const Badge = BADGES[type];

  return (
    <MascotRing tone={type} aria-hidden>
      <MascotFace src={TOAST_MASCOT_SRC} alt="" decoding="async" />
      {Badge && (
        <StatusBadge tone={type}>
          <Badge />
        </StatusBadge>
      )}
    </MascotRing>
  );
};
